// tsc does not recognize jsx extension therefor renaming to tsx
import AuthProvider from '../providers/AuthProvider';

/**
 * Handles successful logout
 * @returns {AuthConsumer}
 * @constructor
 */
export const SignedOutCallback = () => AuthProvider.createConsumer('signedOutRedirectCallback', 'Ajax.signedOutMessage');
